import React, { useState } from 'react';

function GalleryDownloadForm({ onSuccess }) {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!url.trim()) return;

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch('/api/images/download', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ url: url.trim() })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(`Download started: ${data.galleryName || 'Gallery'}`);
        setUrl('');
        if (onSuccess) onSuccess();
      } else {
        setError(data.error || 'Failed to start download');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="download-form-container">
      <form onSubmit={handleSubmit} className="download-form">
        <div className="input-group">
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Paste gallery URL (DeviantArt, ArtStation, Pixiv, etc.)"
            disabled={loading}
            required
          />
          <button 
            type="submit" 
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Starting...' : 'Download'}
          </button>
        </div>
      </form>

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="supported-sites">
        <small>Supported: DeviantArt, ArtStation, Pixiv, Twitter/X, Instagram, Newgrounds, and more</small>
      </div>
    </div>
  );
}

export default GalleryDownloadForm;